"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Content = exports.Container = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const PROPORTION = 16 / 9;
const Container = _styledComponents.default.div`
  padding: 0px 20px;
  margin: 0 auto;
  max-width: 100%;
`;
exports.Container = Container;
const Content = _styledComponents.default.div`
  position: relative;
  width: 100%;

  @media (min-width: 768px) {
    min-height: ${`calc(${100 / PROPORTION}vw - ${40 / PROPORTION}px);`};
    min-width: ${`calc(${100}vw - ${40}px);`};
    max-height: ${`calc(${100 / PROPORTION}vw - ${40 / PROPORTION}px);`};
    max-width: ${`calc(${100}vw - ${40}px);`};
  }

  @media (min-width: 1200px) {
    min-height: ${`calc(${80}vh - ${0}px);`};
    min-width: ${`calc(${80 * PROPORTION}vh - ${0 * PROPORTION}px);`};
    max-height: ${`calc(${80}vh - ${0}px);`};
    max-width: ${`calc(${80 * PROPORTION}vh - ${0 * PROPORTION}px);`};
  }

  .plyr--full-ui input[type='range'] {
    color: aliceblue;
  }
`;
exports.Content = Content;
const Video = ({
  providerUid
}) => {
  const playerRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    const videoOptions = {
      controls: ['play', 'progress', 'mute', 'volume'],
      autoplay: false,
      autopause: false,
      muted: false,
      loop: {
        active: true
      },
      ratio: 16 / 9
    };
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      const Plyr = require('plyr');
      require('plyr/dist/plyr.css');
      playerRef.current = new Plyr(document.getElementById('player'), {
        ...videoOptions
      });
    }
  }, []);
  return _react.default.createElement(Container, null, _react.default.createElement(Content, null, _react.default.createElement("div", {
    class: "plyr__video-embed",
    id: "player"
  }, _react.default.createElement("iframe", {
    src: `https://player.vimeo.com/video/${providerUid}`
  }))));
};
var _default = Video;
exports.default = _default;
//# sourceMappingURL=Video.js.map